import { render, staticRenderFns } from "./main-section-forms.vue?vue&type=template&id=71b382c0"
import script from "./main-section-forms.vue?vue&type=script&lang=js"
export * from "./main-section-forms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports